import { render } from "./DebugView.vue?vue&type=template&id=53269a8a"
import script from "./DebugView.vue?vue&type=script&lang=js"
export * from "./DebugView.vue?vue&type=script&lang=js"

import "./DebugView.vue?vue&type=style&index=0&id=53269a8a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__